(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('notifications', NotificationsDirective)

    /** @ngInject */
    function NotificationsDirective($rootScope, $timeout, HelperService, NotificationService, AuthenticationService, PATHS) {
        function NotificationsDirectiveController($scope) {
            const vm = this;
            let perPage;
            let skip;
            let userData = AuthenticationService.getUserData();

            let removeWatchNotification = $scope.$watch('vm.show', () => {
                vm.loadMore(true);
            })

            $scope.$on('$destroy', () => {
                removeWatchNotification();
            })

            vm.toggleNotification = () => {
                $rootScope.showNotifications = !$rootScope.showNotifications;

                init();
            }

            vm.loadMore = (forcePageReset = false, showLoading = true) => {
                getNotifications(forcePageReset, showLoading);
            }

            vm.markAllRead = () => {
                HelperService.startLoading('.notifications-body');

                NotificationService
                    .postAll(userData.Id, userData.Responsibility.Id)
                    .then(() => {
                        for (let index = 0; index < vm.notificationList.length; index++)
                            vm.notificationList[index].HasPersonRead = true;

                        $rootScope.numberOfNotifications = 0;

                        HelperService.stopLoading('.notifications-body');
                    }, error => {
                        HelperService.stopLoading('.notifications-body');
                        HelperService.errorCallback(error);
                    })
            }

            vm.deleteAll = () => {
                HelperService.startLoading('.notifications-body');

                NotificationService
                    .postAll(userData.Id, userData.Responsibility.Id, true)
                    .then(() => {
                        vm.notificationList = [];
                        vm.hasMoreNotifications = false;
                        $rootScope.numberOfNotifications = 0;

                        HelperService.stopLoading('.notifications-body');
                    }, error => {
                        HelperService.stopLoading('.notifications-body');
                        HelperService.errorCallback(error);
                    })
            }

            vm.markRead = notification => {
                if (notification.HasPersonRead)
                    return;

                HelperService.startLoading('.notifications-body');

                let notificationAccessLog = {
                    NotificationId: notification.Id,
                    PersonId: userData.Id
                };

                NotificationService
                    .post(notificationAccessLog)
                    .then(() => {
                        notification.HasPersonRead = true;
                        $rootScope.numberOfNotifications -= 1;

                        HelperService.stopLoading('.notifications-body');
                    }, error => {
                        HelperService.stopLoading('.notifications-body');
                        HelperService.errorCallback(error);
                    })
            }

            vm.delete = notification => {
                let notificationAccessLog = {
                    NotificationId: notification.Id,
                    PersonId: userData.Id,
                    IsDelete: true
                };

                NotificationService
                    .post(notificationAccessLog)
                    .then(() => {
                        vm.notificationList = vm.notificationList.filter(x => x.Id != notification.Id);
                        $rootScope.numberOfNotifications -= 1;

                        vm.loadMore(true);
                    }, error => HelperService.errorCallback(error));
            }

            init();

            function getNotifications(forcePageReset, showLoading) {
                if (showLoading)
                    HelperService.startLoading('.notifications-body');

                if (forcePageReset) {
                    vm.notificationList = [];
                    skip = 0;
                }

                NotificationService
                    .getAll(userData.Id, userData.Responsibility.Id, perPage, skip)
                    .then(success => {
                        for (let index = 0; index < success.Notifications.length; index++) {
                            const notification = success.Notifications[index];

                            vm.notificationList.push(getNotificationData(notification));
                        }

                        vm.numberOfPages = success.NumberOfPages;
                        vm.hasMoreNotifications = success.Notifications.length >= perPage;
                        skip += vm.notificationList.length;

                        $timeout(() => {
                            vm.isLoading = false;

                            $.fn.scrollbar && $('.notifications-body').scrollbar({
                                ignoreOverlay: false
                            });

                            if (showLoading)
                                HelperService.stopLoading('.notifications-body');
                        })
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.notifications-body');
                    })
            }

            function getNotificationData(notification) {
                let typeId = 0;
                let title = '';
                let description = '';
                let icon = '';
                let uiSref = '';

                if (notification.Communicate) {
                    typeId = 1;
                    title = 'Um novo comunicado foi adicionado';
                    description = notification.Communicate.Title;
                    icon = 'icomoon-communicates';
                    uiSref = `app-master.full-screen.communicates({ communicateUrl: '${notification.Communicate.Url}' })`;
                } else if (notification.Event) {
                    typeId = 2;
                    title = 'Um novo evento foi adicionado';
                    description = notification.Event.Title;
                    icon = 'icomoon-events';
                    uiSref = `app-master.default.events-internal({ eventUrl: '${notification.Event.Url}' })`;
                } else if (notification.FileFolder) {
                    typeId = 3;
                    title = 'Um novo arquivo foi adicionado';
                    description = notification.FileFolder.Title;
                    icon = 'icomoon-files';
                    uiSref = ``;
                } else if (notification.News) {
                    typeId = 4;
                    title = 'Uma nova mídia foi adicionada';
                    description = notification.News.Title;
                    icon = 'icomoon-news';
                    uiSref = `app-master.default.media-internal({ mediaCategory: '${notification.News.NewsCategory.Url}', mediaUrl: '${notification.News.Url}' })`;
                } else if (notification.Ticket && notification.Ticket.TicketTimeline) {
                    typeId = 5;
                    title = `${notification.Ticket.TicketTimeline.Person.Name} atualizou o chamado número ${notification.Ticket.Id}`;
                    description = notification.Ticket.Title;
                    icon = 'icomoon-tickets';
                    uiSref = `app-master.default.helpdesk-internal({ ticketId: '${notification.Ticket.Id}' })`;
                } else if (notification.Video) {
                    typeId = 6;
                    title = 'Um novo video foi adicionado';
                    description = notification.Video.Title;
                    icon = 'icomoon-university';
                    uiSref = `app-master.default.university-internal({ mediaCategory: '${notification.Video.VideoCategory.Url}', mediaUrl: '${notification.Video.Url}' })`;
                }

                if (notification.Comment)
                    title = 'Uma nova resposta no seu comentário foi adicionada'

                return {
                    Id: notification.Id,
                    TypeId: typeId,
                    Title: title,
                    Description: description,
                    Icon: icon,
                    uiSref: uiSref,
                    HasPersonRead: notification.HasPersonRead,
                    RegistrationDate: notification.RegistrationDate
                }
            }

            function init() {
                perPage = 10;
                skip = 0;

                vm.notificationList = [];
                vm.numberOfPages = 0;
                vm.isLoading = true;
            }
        }

        return {
            bindToController: true,
            controller: NotificationsDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/notifications/notifications.html`,
            scope: {
                show: '='
            }
        }
    }
}());